const runner = async () => {
	// window.seoSsrOnly is set by main-body.ejs when the SSR response omits the full viewer model.
	// The SEO flow never hydrates, so there is nothing to boot from - only the essential model from the head exists.
	if (window.__browser_deprecation__ || window.seoSsrOnly) {
		return
	}

	await window.externalsRegistry.lodash.loaded
	// break long task with other scripts that are loaded before main (lodash, etc...)
	setTimeout(() => {
		require('./client')
	}, 0)
}

void runner()
